import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import languageServiceFactory, { LanguageServiceImpl } from "./services/LanguageServiceImpl";
import ScrollToTop from "./custom-components/ScrollToTop";
import { Provider } from "react-redux";
import { store } from "./store";
import { environment } from "./environments/environment";
import { GoogleOAuthProvider } from "@react-oauth/google";

const container = document.getElementById("root");
const root = createRoot(container!);

const languageService = languageServiceFactory();
languageService.initLanguages();

LanguageServiceImpl.lang$.subscribe((lang) => {
    if (languageService.isCurrentLang(lang)) {
        Root();
    }
});

function Root() {
    return (
        <BrowserRouter future={{ v7_relativeSplatPath: true }}>
            <ScrollToTop />
            <Provider store={store}>
                <GoogleOAuthProvider clientId={environment.GOOGLE_CLIENT_ID!}>
                    <App />
                </GoogleOAuthProvider>
            </Provider>
        </BrowserRouter>
    );
}

root.render(
    // <React.StrictMode>
    <Root />
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
